import {
	JiraCoreSiteAri,
	JiraServicedeskSiteAri,
	JiraSiteAri,
	JiraSoftwareSiteAri,
} from '@atlassian/ari';

import type { ResourceContext } from '@townsquare/router/types';

export const collabContextHasJira = (resourceContext: ResourceContext): boolean => {
	return (
		resourceContext.collabContext?.collabContextScoping?.collabContextSiteAris?.some(
			(ari) =>
				JiraSiteAri.check(ari) ||
				JiraSoftwareSiteAri.check(ari) ||
				JiraCoreSiteAri.check(ari) ||
				JiraServicedeskSiteAri.check(ari),
		) ?? false
	);
};
